import { c as _c } from "react/compiler-runtime";
import { SelectInput, sortByLabel } from '@newfront-insurance/core-ui';
import { uniq } from 'lodash';
import * as React from 'react';
import type { JSX } from 'react';
import type { Wholesaler } from '../../../types';
export interface Props {
  data?: Wholesaler[];
  value?: string | null;
  onChange?: (value?: string | null) => unknown;
  disabled?: boolean;
  name?: string;
  innerRef?: React.MutableRefObject<HTMLSelectElement>;
  showSelectAnOption?: boolean;
}
export function WholesalerSelect(props) {
  const $ = _c(14);
  const {
    onChange,
    value,
    disabled,
    name,
    innerRef,
    showSelectAnOption,
    data: t0
  } = props;
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? [] : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const data = t1;
  let t2;
  if ($[2] !== data) {
    t2 = data ? uniq(data).map(_temp).sort(sortByLabel) : [];
    $[2] = data;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const wholesalerOptions = t2;
  let t3;
  if ($[4] !== onChange) {
    t3 = wholesaler_0 => {
      if (onChange) {
        onChange(wholesaler_0);
      }
    };
    $[4] = onChange;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== disabled || $[7] !== innerRef || $[8] !== name || $[9] !== showSelectAnOption || $[10] !== t3 || $[11] !== value || $[12] !== wholesalerOptions) {
    t4 = <SelectInput name={name} options={wholesalerOptions} onChange={t3} value={value} innerRef={innerRef} disabled={disabled} showSelectAnOption={showSelectAnOption} showSelectAnOptionDisabled={false} />;
    $[6] = disabled;
    $[7] = innerRef;
    $[8] = name;
    $[9] = showSelectAnOption;
    $[10] = t3;
    $[11] = value;
    $[12] = wholesalerOptions;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
}
function _temp(wholesaler) {
  return {
    value: wholesaler.id,
    label: wholesaler.name
  };
}